var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
var StyledItem = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n\n  ", "\n"])), function (_ref) {
  var list = _ref.theme.yoga.components.list;
  return "\n    padding:\n      " + list.listItem.padding.top + "px\n      " + list.listItem.padding.right + "px\n      " + list.listItem.padding.bottom + "px\n      " + list.listItem.padding.left + "px;\n  ";
});

var ListItem = function ListItem(_ref2) {
  var rest = _extends({}, _ref2);

  return /*#__PURE__*/React.createElement(StyledItem, rest);
};

ListItem.displayName = 'List.Item';
export default ListItem;